import { VStack } from '@ayble-health/dashboard-components';
import { Footer } from './Footer';
import { Headline } from './Headline';
import { Header } from './Header';

export const LandingPage = () => {

  return (
    <VStack data-testid={'landing-page'}>
      <Header />
      <Headline />
      <Footer />
    </VStack>
  );
};
